import styled from 'styled-components/macro'

export const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  & + & {
    margin-top: 24px;
  }
`

export const GroupTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.mutedText};
  padding: 0 4px;

  span {
    font-weight: 500;
  }
`

export const Row = styled.a`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${props => props.theme.pageBackground};
  color: ${props => props.theme.normalText};
  text-decoration: none;
  transition:
    background 0.15s ease,
    transform 0.15s ease;

  &:hover {
    background: ${props => props.theme.accentForHover};
  }

  &:active {
    transform: scale(0.98);
  }

  .text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .name {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .meta {
    font-size: 14px;
    color: ${props => props.theme.mutedText};
  }

  .slug {
    font-size: 14px;
    font-weight: 500;
    color: ${props => props.theme.mutedText};
    white-space: nowrap;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .open-icon {
    flex: none;
    font-size: 14px;
    color: ${props => props.theme.accent};
  }
`

export const Tag = styled.span`
  font-size: 14px;
  font-weight: 600;
  padding: 0 8px;
  border-radius: 8px;
  background: ${props => props.theme.darkBlue};
  color: ${props => props.theme.white};
`
